import { render, staticRenderFns } from "./PaymentPack.vue?vue&type=template&id=70495d28&scoped=true&"
import script from "./PaymentPack.vue?vue&type=script&lang=js&"
export * from "./PaymentPack.vue?vue&type=script&lang=js&"
import style0 from "./PaymentPack.vue?vue&type=style&index=0&id=70495d28&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "70495d28",
  null
  
)

export default component.exports